export const discreteValue = (value: number, base: number) => (base !== 0 ? Math.floor(value / base) * base : value);

export const positiveDiscreteValue = (value: number, base: number) => Math.max(discreteValue(value, base), 0);

export const negativeDiscreteValue = (value: number, base: number) => Math.min(discreteValue(value, base), 0);
